export const DEFAULT_HOLDING_DETAILS = {
  collateralQnty: '',
  collateralValue: 0,
  currentValue: '',
  day: 0,
  dayPercentage: '',
  haircut: '',
  investment: '',
  netQnty: 0,
  overall: 0,
  overallPercentage: '',
  totalQnty: '',
  usedQnty: '',
  dematQty: 0,
  t1Qty: 0,
};
